var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolOkapps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2812_77067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.456 64.0034C115.456 35.5863 115.456 12.5506 63.9992 12.5506C12.5437 12.5506 12.5437 35.5863 12.5437 64.0034C12.5437 92.4212 12.5437 115.458 63.9992 115.458C115.456 115.458 115.456 92.4212 115.456 64.0034ZM63.9992 0C99.347 0 128 28.659 128 64.0034C128 99.3485 99.347 128 63.9992 128C28.653 128 0 99.3485 0 64.0034C0 28.659 28.653 0 63.9992 0V0Z",
    fill: "#005342"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2812_77067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolOkapps);
export default __webpack_public_path__ + "static/media/symbol-okapps.0e0824e163e8e2f3fd629b968dae7e10.svg";
export { ForwardRef as ReactComponent };